import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default {
  exact: true,
  path: '/home/sys/panel',
  owner: '/home',
  authority: 'panelList',
  component: Loadable({
    loader: () => import('./index'),
    loading: () => <RouteLoading />
  })
};